import styled from 'styled-components';

const FormInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
`;

const TitleAndNameRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S12};

  > *:first-child {
    flex: 0 0 108px;
  }

  > *:last-child {
    flex: 1;
  }
`;

export { FormInputsContainer, TitleAndNameRow };
